import PubSub from "underpub-js";
import tippy, {
  followCursor
} from 'tippy.js';
import 'tippy.js/animations/shift-toward.css';

const attomApiKey = "a97989257d5cfd490f360a99b2f7a4e4";

var CalculatorExtended = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-CalculatorExtended',
  };

  $.extend(true, this.options, options);

};

CalculatorExtended.prototype.init = function () {

  var self = this;

  const $form = this.options.$el.find('.fui-form');
  const $formPages = $form.find(".fui-page");
  const $numberInputs = $form.find("input[data-type='number']");
  let data = {};
  // Update index to be page number -1 if no intro step is used
  const $page1 = $form.find(".fui-page[data-index='0']");
  const $page2 = $form.find(".fui-page[data-index='1']");
  const $page3 = $form.find(".fui-page[data-index='2']");
  const $page4 = $form.find(".fui-page[data-index='3']");
  const $page5 = $form.find(".fui-page[data-index='4']");
  const $totalCurrentExpenses = $form.find(".total-current-expenses");
  const $totalPriyaExpenses = $form.find(".total-priya-expenses");
  const $costOfLivingReportComments = $form.find(".cost-of-living-report-comments");

  // Page 1 inputs
  const $mortgageHoaInput = $page1.find("[name='fields[mortgageHoa]']");
  const $insuranceInput = $page1.find("[name='fields[insurance]']");
  const $utilitiesInput = $page1.find("[name='fields[utilities]']");
  const $foodDiningInput = $page1.find("[name='fields[foodDining]']");
  const $entertainmentInput = $page1.find("[name='fields[entertainment]']");
  const $autoInput = $page1.find("[name='fields[auto]']");
  const $transportationInput = $page1.find("[name='fields[transportation]']");
  const $housekeepingInput = $page1.find("[name='fields[housekeeping]']");
  const $wellnessInput = $page1.find("[name='fields[wellness]']");
  const $selfCareInput = $page1.find("[name='fields[selfCare]']");
  const $maintenanceInput = $page1.find("[name='fields[maintenance]']");
  const $propertyTaxesInput = $page1.find("[name='fields[propertyTaxes]']");
  const $internetCableInput = $page1.find("[name='fields[internetCable]']");
  // Page 3 inputs
  const $priyaMembershipFeeInput = $page3.find("[name='fields[priyaMembershipFee]']");
  // Total inputs
  const $costOfLivingReportInput = $page4.find("[name='fields[resultsCostOfLivingReport]']");

  const removeNumberFormat = number => parseFloat(number.toString().replace(/[^0-9.]/g, ''));
  const applyNumberFormat = (number, addDecimals = false) => {
    const baseNumber = addDecimals ? parseFloat(number).toFixed(2) : parseFloat(number).toString();
    return baseNumber.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
  };
  const applyCurrencyFormat = (number) => `$${applyNumberFormat(number, true)}`;

  // If intro step is used, steps match the index, if no intro step is used, add + 1 to get accurate page id
  const getCurrentPageId = () => $formPages.not(".fui-hidden").data("index") + 1;

  const getPage1Data = () => {
    const mortgageHoa = removeNumberFormat($mortgageHoaInput.val()) || 0;
    const insurance = removeNumberFormat($insuranceInput.val()) || 0;
    const utilities = removeNumberFormat($utilitiesInput.val()) || 0;
    const foodDining = removeNumberFormat($foodDiningInput.val()) || 0;
    const entertainment = removeNumberFormat($entertainmentInput.val()) || 0;
    const auto = removeNumberFormat($autoInput.val()) || 0;
    const transportation = removeNumberFormat($transportationInput.val()) || 0;
    const housekeeping = removeNumberFormat($housekeepingInput.val()) || 0;
    const wellness = removeNumberFormat($wellnessInput.val()) || 0;
    const selfCare = removeNumberFormat($selfCareInput.val()) || 0;
    const maintenance = removeNumberFormat($maintenanceInput.val()) || 0;
    const propertyTaxes = removeNumberFormat($propertyTaxesInput.val()) || 0;
    const internetCable = removeNumberFormat($internetCableInput.val()) || 0;

    data = {
      ...data,
      currentExpenses: {
        ...data.currentExpenses,
        mortgageHoa,
        insurance,
        utilities,
        foodDining,
        entertainment,
        auto,
        transportation,
        housekeeping,
        wellness,
        selfCare,
        maintenance,
        propertyTaxes,
        internetCable
      }
    }
  }

  const getPage3Data = () => {
    const priyaMembershipFee = removeNumberFormat($priyaMembershipFeeInput.val()) || 0;

    data = {
      ...data,
      priyaMembershipFee
    }
  }

  const setExpensesData = () => {
    data = {
      ...data,
      currentExpenses: {
        ...data.currentExpenses,
        total: data.currentExpenses.mortgageHoa +
          data.currentExpenses.insurance +
          data.currentExpenses.utilities +
          data.currentExpenses.foodDining +
          data.currentExpenses.entertainment +
          data.currentExpenses.auto +
          data.currentExpenses.transportation +
          data.currentExpenses.housekeeping +
          data.currentExpenses.wellness +
          data.currentExpenses.selfCare +
          data.currentExpenses.maintenance +
          data.currentExpenses.propertyTaxes +
          data.currentExpenses.internetCable
      }
    }
  }

  const initTooltips = () => {
    const tooltips = $("[data-tooltip]");

    tooltips.each((index, item) => {
      const $item = $(item);
      const tooltipHeading = $item.data("text");
      const tooltipText = $item.data("tooltip");

      tippy($item[0], {
        content: `
          ${tooltipHeading && tooltipHeading.length ? `<h5>${tooltipHeading}</h5>` : ""}
          <p>${tooltipText}</p>
        `,
        allowHTML: true,
        arrow: true,
        theme: 'primary',
        inertia: true,
        animation: 'shift-toward',
        duration: [500, 300],
        delay: 100,
        followCursor: "horizontal",
        plugins: [followCursor],
      });
    })
  }

  const setTotals = () => {
    const expensesData = [{
      text: "Mortgage & HOA",
      value: applyCurrencyFormat(data.currentExpenses.mortgageHoa),
      tooltip: "Maintaining your homeownership means mortgage & HOA payments will continue after your move to Priya."
    }, {
      text: "Property Taxes",
      value: applyCurrencyFormat(data.currentExpenses.propertyTaxes),
      tooltip: "Calculation based on your city and county."
    }, {
      text: "Maintenance",
      value: applyCurrencyFormat(data.currentExpenses.maintenance),
      tooltip: "Maintaining your homeownership means maintence expenses will continue after your move to Priya.",
    }, {
      text: "Insurance",
      value: applyCurrencyFormat(data.currentExpenses.insurance),
      tooltip: "Maintaining your homeownership means insurance payments will continue after your move to Priya."
    }, {
      text: "Utilities",
      value: applyCurrencyFormat(data.currentExpenses.utilities),
      tooltip: "Maintaining homeownership means utility payments will continue after your move to Priya; community utilities are included in your membership fee."
    }, {
      text: "Food & Dining",
      value: applyCurrencyFormat(data.currentExpenses.foodDining),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Meal program is included in your membership fee."
    }, {
      text: "Entertainment",
      value: applyCurrencyFormat(data.currentExpenses.entertainment),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Your membership fee includes comprehensive programming and activities."
    }, {
      text: "Auto",
      value: applyCurrencyFormat(data.currentExpenses.auto),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Your membership fee includes one parking spot."
    }, {
      text: "Transportation",
      value: applyCurrencyFormat(data.currentExpenses.transportation),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Your membership fee includes access to scheduled Priya transportation services."
    }, {
      text: "Internet & Cable",
      value: applyCurrencyFormat(data.currentExpenses.internetCable),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Internet access is included in your membership fee."
    }, , {
      text: "Housekeeping",
      value: applyCurrencyFormat(data.currentExpenses.housekeeping),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Your membership fee includes regularly scheduled housekeeping services."
    }, {
      text: "Wellness",
      value: applyCurrencyFormat(data.currentExpenses.wellness),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Comprehensive fitness classes, wellness programs and gym privileges are included in your membership fee."
    }, {
      text: "Self-care",
      value: applyCurrencyFormat(data.currentExpenses.selfCare),
      valueAtPriya: applyCurrencyFormat(0),
      tooltip: "Priya offers on-site salon services."
    }];

    let totalsData = [{
        text: "Membership Fee",
        value: applyCurrencyFormat(data.priyaMembershipFee),
        showSeparator: true
      },
      {
        text: "Monthly Net Expenses",
        value: applyCurrencyFormat(data.currentExpenses.total),
        showSeparator: true
      }
    ];

    // Sorting by value in descending order
    totalsData = totalsData.sort((a, b) => {
      return parseInt(removeNumberFormat(b.value)) - parseInt(removeNumberFormat(a.value));
    });

    const differenceTotal = Math.abs(data.priyaMembershipFee - data.currentExpenses.total);

    totalsData = [...totalsData,
      {
        text: "Difference",
        value: applyCurrencyFormat(differenceTotal),
        showSeparator: true
      }
    ];

    const totalCurrentExpensesHtml = `
      <div class="results">
        <h3 class="heading">Monthly Net Expenses Today</h3>
        <div class="section">
          <div class="subsection">
          ${expensesData.map(item => `<div class="item">
              <span class="item__text">${item.text}</span>
              <span class="item__value">${item.value}</span>
            </div>`).join("")}
          </div>
        </div>
        <div class="separator"></div>
        <div class="section">
          <div class="section__header item item--total">
            <span class="item__text">Total</span>
            <span class="item__value">${applyCurrencyFormat(parseInt(data.currentExpenses.total))}</span>
          </div>
        </div>
      </div>
    `;

    const totalPriyaExpensesHtml = `
      <div class="results">
        <h3 class="heading">Current Monthly Expenses vs. Priya Living Expense</h3>
        ${totalsData.map(item => `
          ${item.showSeparator ? `<div class="separator"></div>` : ""}
          <div class="section">
            <div class="section__header item ${item.isTotal ? "item--total" : ""}" ${item.tooltip && item.tooltip.length ? `data-tooltip='${item.tooltip}' data-text='${item.text}'` : ""}>
              <span class="item__text">${item.text}</span>
              <span class="item__value">${item.value}</span>
            </div>
            ${item.showExpensesData ? `
              <div class="subsection subsection--inset">
                ${expensesData.map(item => `<div class="item" ${item.tooltip && item.tooltip.length ? `data-tooltip='${item.tooltip}' data-text='${item.text}'` : ""}>
                  <span class="item__text">${item.text}${item.valueAtPriya && item.valueAtPriya == "0" ? "*" : ""}</span>
                  <span class="item__value">${item.valueAtPriya || item.value}</span>
                </div>`).join("")}
              </div>
            ` : ""}
          </div>
        `).join("")}
      </div>
    `;

    let costOfLivingReportResults = "";

    const costOfLivingReportResultsMembership = `Priya Membership Fee: ${applyCurrencyFormat(parseInt(data.priyaMembershipFee))}`;
    const costOfLivingReportResultsExpenses = `Monthly Net Expenses: ${applyCurrencyFormat(parseInt(data.currentExpenses.total))}`;
    const costOfLivingReportResultsDifference = `Difference: ${applyCurrencyFormat(differenceTotal)}`;

    if (parseInt(data.priyaMembershipFee) >= parseInt(data.currentExpenses.total)) {
      costOfLivingReportResults = `
${costOfLivingReportResultsMembership}
${costOfLivingReportResultsExpenses}
${costOfLivingReportResultsDifference}
      `
    } else {
      costOfLivingReportResults = `
${costOfLivingReportResultsExpenses}
${costOfLivingReportResultsMembership}
${costOfLivingReportResultsDifference}
      `
    }

    const costOfLivingReportCommentsHtml =
      `${data.priyaMembershipFee > data.currentExpenses.total ? "<p>Your current cost of living may be less than your Priya membership fee, but you’re missing out on a life filled with great meals shared with new friends, programming that helps you stay active and engaged, concierge services and much more!</p>" : "<p>This is how much you could save by living with us. But please keep in mind that you’ll probably still have some discretionary spending on dining out, outside entertainment, transportation, etc.</p>"}`;

    $costOfLivingReportComments.html(costOfLivingReportCommentsHtml);

    $totalCurrentExpenses.html(totalCurrentExpensesHtml);
    $totalPriyaExpenses.html(totalPriyaExpensesHtml);
    $costOfLivingReportInput.val(costOfLivingReportResults);
    initTooltips();
  }

  const handleData = () => {
    const currentPageId = getCurrentPageId();

    switch (currentPageId) {
      case 1:
        getPage1Data();
        setExpensesData();
        setTotals();
        break;
      case 2:
        getPage1Data();
        setExpensesData();
        setTotals();
        break;
      case 3:
        getPage1Data();
        getPage3Data();
        setExpensesData();
        setTotals();
        break;
      case 4:
        getPage1Data();
        getPage3Data();
        setExpensesData();
        setTotals();
        break;
      default:
        break;
    }

    console.log("Data:", data);
  }

  const handleFunctionality = () => {
    const currentPageId = getCurrentPageId();
  }

  $numberInputs.on('focus', e => {
    const $input = $(e.target);
    const inputValue = $input.val();

    if (inputValue) {
      $input.val(removeNumberFormat($input.val()));
    }
  })

  $numberInputs.on('blur', e => {
    const $input = $(e.target);
    const inputValue = $input.val();
    const addDecimals = $input.closest("[data-symbol='dollar']").length;

    if (inputValue) {
      $input.val(applyNumberFormat($input.val(), addDecimals));
    }
  })

  handleData();
  handleFunctionality();
  $form.on('onBeforeFormieSubmit', handleData);
  $form.on('onAfterFormieSubmit', handleFunctionality)
};

export default CalculatorExtended;